import React from 'react';
export const AnimateContext = React.createContext({ animated: true });
